import PropTypes from "prop-types"
import React, { useState } from "react"

import ChildItem from "../ChildItem"
import css from "./ChildrenItem.scss"
import { getAssetPath } from "@commonUtils"
import { isPwaUrl } from "@lib/urlMatchUtility"
import GaEvents from "@containers/Header/GaEvents"
import ImageLoader from "@components/ImageLoader/ImageLoader"
import ConditionalLink from "@wrappers/ConditionalLink/ConditionalLink"

const chevronDownIcon = getAssetPath("svgs/icons/chevron-down_18px_primary.svg")

const getPosition = (id) => {
    let pos = "right"
    if (window && document) {
        const element = document.getElementById(id)
        const { left, right } = (element && element.getBoundingClientRect()) || {}
        const { innerWidth } = window
        if (right > innerWidth / 2 && left + right - innerWidth > 80) {
            pos = "left"
        }
    }
    return pos
}

const ChildrenItem = ({ item, id }) => {
    const [position, setPosition] = useState("right")
    const key = `${item.parent.name}__${id}`
    return (
        <li className={`${css.item}`}>
            <div
                id={key}
                className={`flex alignCenter ${css.parent}`}
                onClick={() => setPosition(getPosition(key))}
                onMouseEnter={() => setPosition(getPosition(key))}
            >
                <ConditionalLink
                    to={item.parent.slug}
                    isExternal={!isPwaUrl(item.parent.slug)}
                    onClick={() => GaEvents.onUdpDesktopClick(`${item?.parent?.name}, ${location.href}`)}
                >
                    <span className={`${css.linkText}`}>{item.parent.name}</span>
                </ConditionalLink>
                <ImageLoader height="12px" width="12px" src={chevronDownIcon} alt="chevron down" />
            </div>
            <div className={`${css.childCategoryLinks} ${position === "left" ? `${css.right0}` : ""}`}>
                {item.children.map(
                    (segmentChild, k) =>
                        segmentChild.length > 0 && <ChildItem segmentChild={segmentChild} key={k} />
                )}
            </div>
        </li>
    )
}

ChildrenItem.propTypes = {
    id: PropTypes.number,
    item: PropTypes.object,
}

export default ChildrenItem
